// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-linear-gradient-left[data-v-76a9c55a]{background:linear-gradient(90deg,#162440,hsla(0,0%,100%,0))}.custom-linear-gradient-right[data-v-76a9c55a]{background:linear-gradient(90deg,hsla(0,0%,100%,0),#162440)}.no-scrollbar[data-v-76a9c55a]::-webkit-scrollbar{display:none}.no-scrollbar[data-v-76a9c55a]{-ms-overflow-style:none;scrollbar-width:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
